

import { Box, Flex, Text, IconButton, Icon, Button, useDisclosure } from '@chakra-ui/react'
import { TbDots } from "react-icons/tb";
import LazyAvatar from "../../components/lazy/LazyAvatar";
import { getEventLabel } from '../../types/EventTypes';
import { useNavigate } from 'react-router-dom';
import { getCoachAvailability } from '../../api/user/profile/Profile';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import DatePickerModal from '../modals/DatePickerModal';
import { deletePrivateClass, switchPrivateClass } from '../../api/user/notifications/Notifications';

const formatDateTime = (date: Date): string => {
    const today = new Date();
    const tomorrow = new Date(today);

    const isToday = date.toDateString() === today.toDateString()
    const isTomorrow = date.toDateString() === tomorrow.toDateString()
    const longOptions: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'long',
        hour: 'numeric',
        minute: 'numeric',
    };


    const shortOptions: Intl.DateTimeFormatOptions = {
        hour: 'numeric',
        minute: 'numeric',
    };


    tomorrow.setDate(today.getDate() + 1);
    tomorrow.setHours(12, 30, 0, 0);

    if (isToday) {
        return `Today, ${date.toLocaleTimeString('en-US', shortOptions)}`;
    } else if (isTomorrow) {
        return `Tomorrow, ${date.toLocaleTimeString('en-US', shortOptions)}`;
    } else {
        return date.toLocaleDateString('en-US', longOptions);
    }
};


const PrivateClassJoinedCard = ({id , package_id, duration , time , type, coach, onExtraOptionsOpen, isTablet} : {
    id : string,
    package_id : string,
    duration : number,
    isTablet : boolean,
    time : string,
    type : string,
    coach : any,
    onExtraOptionsOpen : () => void,

}) => {

    const navigate = useNavigate()

    const {
        isOpen : isDatePickerOpen,
        onClose : onDatePickerClose,
        onOpen : onDatePickerOpen,
    } = useDisclosure()

    const availability = useQuery(["bookingAvailability"], () => getCoachAvailability({
        id : package_id,
    }), {
        enabled : id !== null,
    })

    const queryClient = useQueryClient()

    const switchSlots = useMutation(["switchSlots"], switchPrivateClass, {
        onSuccess : () => {
            onDatePickerClose()
            queryClient.invalidateQueries(["upcomingEvents"])

        },
    })

    const deleteSlot = useMutation(["deleteSlot"], deletePrivateClass, {
        onSuccess : () => {
            
            queryClient.invalidateQueries(["upcomingEvents"])
        }
    })

    return <>
    <DatePickerModal
        isOpen={isDatePickerOpen}
        onClose={onDatePickerClose}
        availability={availability}
        isLoading={switchSlots.isLoading}
        onSave = {(start_time : string) => {
            switchSlots.mutate({
                id : id,
                to : start_time,
            })
        }}
        
    />

    
    <Box
        bg='white'
        borderRadius='10px'
        boxShadow='0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14'
        
        w='100%'
        maxW="100%"
        minW="100%"
        borderWidth='1px'
        borderColor='#DCE2EA' overflow='hidden'
        pos='relative'
    >
        <Flex>
        <Flex ml='10px' mt='20px' gap="9px" alignItems={"center"}>
            <LazyAvatar
                src={coach?.profile_image ?? ""}
                key={coach?.id} width={26} height={26} border='1px solid #dce2ea' 
                onClick={() => navigate(`/user/profile?id=${coach?.id}`)}
                _hover={{cursor : "pointer"}}
            />
            <Text fontWeight={"500"} fontSize="13px">{coach?.display_name}</Text>
        </Flex>
        <IconButton 
            right='5px' top='5px'
            variant='unstyled'
            icon={<Icon as={TbDots}  w='22px' h='22px' />}
            position='absolute'
            aria-label="Options"

            onClick={() => {
                onExtraOptionsOpen()
            }}
        />
        </Flex>
        <Flex justifyContent="space-between" p="20px" pb="0">
            <Flex alignItems='center' gap='4px'>
                <Text variant='header' fontSize={isTablet ? '12' : '15'}>
                    Duration:
                </Text>
                <Text variant='subtle' fontSize={isTablet ? '11' : '13'} fontWeight='400' mt='2px'>
                    {duration} min
                </Text>
            </Flex>
            <Flex alignItems='center' gap='4px'>
                <Text variant='header' fontSize={isTablet ? '12' : '15'}>
                    Time:
                </Text>
                <Text variant='subtle' fontSize={isTablet ? '11' : '13'} fontWeight='400' mt='2px'>
                    {formatDateTime(new Date(time))}
                </Text>
            </Flex>
            <Flex alignItems='center' gap='4px'>
                <Text variant='header' fontSize={isTablet ? '12' : '15'}>
                    Type:
                </Text>
                <Text variant='subtle' fontSize={isTablet ? '11' : '13'} fontWeight='400' mt='2px'>
                    {getEventLabel(type)}
                </Text>
            </Flex>
        </Flex>

        <Flex justifyContent={"space-between"} p='20px' alignItems='center' gap='10px'>
        <Text
            fontWeight='600'
            color='#171C22'
            fontSize='lg'
        >
            {duration} min
        </Text>

        <Flex gap='10px'>
            <Button variant='light' fontWeight={!isTablet ? '600' : undefined}
                size={isTablet ? 'sm' : undefined}
                onClick={() => {
                    onDatePickerOpen()
                }}
                
            >
                Switch Time
            </Button>
            <Button variant='light' fontWeight={!isTablet ? '600' : undefined}
                size={isTablet ? 'sm' : undefined}
                isLoading={deleteSlot.isLoading}
                onClick={() => {
                    deleteSlot.mutate({
                        id : id,
                    })
                }}
            >
                Cancel
            </Button>
        </Flex>
        </Flex>

    </Box>
    </>
}

export default PrivateClassJoinedCard;